import { RootStateTypes } from './types';
import { GetterTree } from 'vuex';

const getters: GetterTree<RootStateTypes, any> = {
    routeName: (state: RootStateTypes) => state.routeName,
    accountDialogType: (state: RootStateTypes) => state.accountDialogType,
    showAccountDialog: (state: RootStateTypes) => state.accountDialogType !== '',
    userInfo: (state: RootStateTypes) => state.userInfo,
};
export default getters;
